import { SvgInfoCircularHollow } from "@itwin/itwinui-icons-react"
import { IconButton, Label, Tooltip } from "@itwin/itwinui-react"
import styles from "./InfoLabel.module.css";

interface InfoLabelProps {
  label?: string;
  toolTip?: string;
  toolTipPlacement?: any;
  required?: boolean;
}


export const InfoLabel = ({ label, toolTip, toolTipPlacement = "bottom", required }: InfoLabelProps) => {

  if (!label)
    return null;

  return (
    <Label className={styles.label} required={required} as="span">
      {toolTip && <Tooltip content={toolTip} placement={toolTipPlacement} delay={500}>
        <IconButton styleType="borderless" size="small">
          <SvgInfoCircularHollow />
        </IconButton>
      </Tooltip>}
      {label}
    </Label>
  )
}